import React, { useCallback, useState } from 'react';
import { useProject } from 'Project';
import styled from '@emotion/styled';
import { connectedApp } from 'components/App';
import queryString from 'query-string';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import cx from 'classnames';

export const Container = styled.div`
  border-radius: 6px;
`;

export const Category = styled.span`
  padding: 8px;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.1;
  border: none;
  display: inline-block;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0 8px 12px 0;
  transition: background 100ms, color 100ms;
  &:hover {
    opacity: 0.9;
  }
`;

const StyledDropdownToggle = styled(DropdownToggle)`
  background-color: #eaebee;
  border-bottom: 1px solid #dbe0e4;
  fontSize: 14px;

  &:hover, &:active, &:hover:active, &:focus {
    border-bottom: 1px solid #dbe0e4 !important;
  }

  &:after {
    margin-left: auto;
    margin-top: 8px;
    float: right;
  }
`;

const ViewsSelector = ({ value, options, filterCategories }) => {
  const [open, updateOpen] = useState(false);
  const toggle = useCallback(() => updateOpen(!open), [open]);

  const loadView = useCallback(({ slug }) => {
    location.search = queryString.stringify({
      view: slug,
      categories: Array.from(filterCategories).join(','),
    });
  }, [options, filterCategories]);

  return (
    <Dropdown isOpen={open} toggle={toggle}>
      <StyledDropdownToggle className="text-left m-0 btn-block p-3" caret>
        { value.name }
      </StyledDropdownToggle>
      <DropdownMenu>
        {options.map(({ slug, name }) => (
          <DropdownItem onClick={() => loadView({ slug })} key={slug}>
            { name }
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export const CategoriesHeading = ({ clear }) => (
  <div className="heading clearfix px-3 pt-3">
    <div className="float-left d-flex align-items-center primary-text-color" style={{ fontSize: 16 }}>
      <strong>Categories</strong>
    </div>
    <div className="float-right">
      <a
        className="primary-text-color"
        href="#"
        onClick={clear}
      >
        <small>Clear</small>
      </a>
    </div>
  </div>
);

export const CategoriesCloud = ({ value, categories, onToggle, ...props }) => (
  <div className="categories pt-3 px-3 pb-2" {...props}>
    {categories.map(({ id, name, description }) => (
      <Category
        key={id}
        data-title={description}
        onClick={() => onToggle(id)}
        style={{
          backgroundColor: value.has(id) ? null : 'rgba(255, 255, 255, 0.25)',
        }}
        className={cx({
          'primary-text-color': !value.has(id),
          'white-color primary-background': value.has(id) },
        )}
        selected={value.has(id)}
      >
        {name}
      </Category>
    ))}
  </div>
);

const ReleasesFilter = ({ selectedCategories, view, views, location }) => {
  const { categories } = useProject();
  const [filterCategories, updateFilterCategories] = useState(new Set(selectedCategories || []));

  const toggleCategory = useCallback((categoryId) => {
    let newFilteredCategories = new Set(filterCategories);
    if (filterCategories.has(categoryId)) {
      newFilteredCategories.delete(categoryId)
    } else {
      newFilteredCategories.add(categoryId);
    }

    const searchTerms = {
      categories: Array.from(newFilteredCategories).join(','),
      view: view.slug,
    };

    let currentParams = new URLSearchParams(window.location.search)
    if (currentParams.has("search"))  { searchTerms["search"] = currentParams.get("search") }

    const search = queryString.stringify(searchTerms)

    const frame = document.querySelector("turbo-frame#outlet");
    if (!!frame) {
      frame.src = `${location}?${search}`;
      const newURL = `${window.location.protocol}//${window.location.host}${location}?${search}`
      window.history.pushState({}, '', newURL);
      window.Turbo.navigator.history.push(newURL);
    }
  }, [filterCategories, updateFilterCategories]);

  const clearFilter = useCallback((e) => {
    e.preventDefault();
    const searchTerms = {
      view: view.slug,
    };
    let currentParams = new URLSearchParams(window.location.search)
    if (currentParams.has("search"))  { searchTerms["search"] = currentParams.get("search") }

    const search = queryString.stringify(searchTerms);

    const frame = document.querySelector("turbo-frame#outlet");
    if (!!frame) {
      frame.src = `${location}?${search}`;
      const newURL = `${window.location.protocol}//${window.location.host}${location}?${search}`
      window.history.pushState({}, '', newURL);
      window.Turbo.navigator.history.push(newURL);
    }
  }, [view])

  return (
    <Container className="light-gray-background">
      { views ?
        <div>
          <ViewsSelector
            value={view}
            options={views}
            onChange={(value) => { console.log(value) }}
            filterCategories={filterCategories}
          />
        </div>
      : null}

      <CategoriesHeading clear={clearFilter} />

      <CategoriesCloud
        categories={categories}
        onToggle={toggleCategory}
        value={filterCategories}
      />
    </Container>
  );
};

export default connectedApp(ReleasesFilter);
